
import Vue from "vue";
export default Vue.extend({
  name: "Modal",
  props: {
    title: String,
    dialog: Boolean,
    persistent: Boolean,
    width: String,
    loading: Boolean,
    editar: Boolean,
    scrollable:{
      type: Boolean,
      default: false,
    },
    fullscreen: {
      type: Boolean,
      default: false,
    },
    mostrarBotones: {
      type: Boolean,
      default: true,
    },
    mostrarBotonCerrar: {
      type: Boolean,
      default: true,
    },
    mostrarBotonGuardar: {
      type: Boolean,
      default: true,
    },
    textoGuardar: {
      type: String,
      default: "Guardar",
    },
    textoCerrar: {
      type: String,
      default: "Cerrar",
    },
  },
  data() {
    return {
      windowWidth: window.innerWidth,
    };
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
  },

  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },

  methods: {
    onResize() {
      this.windowWidth = window.innerWidth;
    },
  },
});
